<template>
    <ion-page>
        <standard-header title="All Packs" align="middle"/>
        <ion-content :fullscreen="true">
            <pull-down-refresh :callback="refresh"/>
            <skeleton :rows="4" v-if="shipments === null"/>
            <div v-show="shipments && shipments.length < 1">
                <no-results title="No Results">
                    No shipments found due for packing
                </no-results>
            </div>
            <div v-if="shipments !== null">
                <ion-item>
                    <ion-label>Filter by Drop Off</ion-label>
                    <ion-select v-model="currentZoneId">
                        <ion-select-option :value="null">All</ion-select-option>
                        <ion-select-option :value="zone.id" v-for="zone in zones" :key="zone.id">
                            {{ zone.name }}
                        </ion-select-option>
                    </ion-select>
                </ion-item>
                <ion-list>
                    <div v-for="shipment in filteredShipments" :key="shipment.id">
                        <ion-item lines="none" class="ion-no-padding">
                            <ion-button fill="clear" size="small" style="height: 100%" @click="showLines(shipment)">
                                <ion-icon slot="icon-only" :icon="listOutline" />
                            </ion-button>
                            <pick-list-item
                                :shipment="shipment"
                                :hide-due="true"
                                :duration-source="shipment.packers"
                            />

                            <shipment-membership-tools
                                type="shipments"
                                stage="pack"
                                name="pack"
                                @updated="refresh()"
                                ref="members"
                                :job="shipment"
                                :users="shipment.packers"
                            />


                            <shipment-stock-take-user-assignment
                                v-if="false"
                                :lineable-update-url="`/api/shipments/${shipment.id}/users`"
                                user-permission="warehouse.pack"
                                :lineable="shipment"
                                :users="users"
                                users-property="packers"
                                :update-payload="{action:'none', stage: 'pack'}"
                            />
                        </ion-item>
                        <ion-progress-bar :value="shipment.pc_complete/100"/>
                    </div>
                </ion-list>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
import {
    alertController,
    IonContent,
    IonItem,
    IonList,
    IonPage,
    IonButton,
    IonIcon,
    IonProgressBar,
    IonSelect, IonSelectOption, IonLabel
} from '@ionic/vue';
import StandardHeader from "@/components/StandardHeader.vue";
import NoResults from "@/components/NoResults";
import EventBus from '@/EventBus';
import Skeleton from "@/components/Skeleton";
import PullDownRefresh from "@/components/PullDownRefresh";
import PrioritySorter from "@/services/PrioritySorter";
import PickListItem from "@/views/modules/picking/components/PickListItem";
import _ from 'lodash';
import ShipmentStockTakeUserAssignment from "@/components/ShipmentStockTakeUserAssignment";
import {listOutline} from "ionicons/icons";
import ShipmentMembershipTools from "@/components/ShipmentMembershipTools";

export default {
    inject: ['$http', '$toast', '$validationAlert'],
    name: 'AllPicksList',
    components: {
        ShipmentMembershipTools,
        ShipmentStockTakeUserAssignment,
        PickListItem,
        PullDownRefresh,
        Skeleton,
        NoResults,
        StandardHeader,
        IonContent, IonPage, IonItem, IonList, IonButton, IonIcon,
        IonProgressBar,
        IonSelect, IonSelectOption, IonLabel
    },
    computed: {
        filteredShipments() {
            if (!this.currentZoneId) {
                return this.shipments;
            }
            return _.filter(this.shipments, shipment => {
                return shipment.picking_drop_off_zone_id === this.currentZoneId;
            });
        }
    },
    data() {
        return {
            currentZoneId: null,
            zones: [],
            shipments: null,
            users: []
        }
    },
    async mounted() {
        EventBus().emitter.emit('loading', true);
        await this.getUsers();
        await this.refresh();
        EventBus().emitter.emit('loading', false);
    },
    methods: {
        ionViewDidEnter() {

            EventBus().emitter.emit('loading', true);
            this.$http.get('/api/locations/zones?search=is_bay:1').then(response => {
                this.zones = response.data.items;
            }).catch(error => {
                this.$validationAlert(error);
            }).finally(() => {
                EventBus().emitter.emit('loading', false);
            });

            this.refresh();
        },
        showLines(shipment) {
            alertController.create({
                header: shipment.reference,
                message: _.map(shipment.lines, (line) => { return `&bull; ${line.qty_required} x ${line.item.item_number} @ ${line.location.code}`; }).join('<br />'),
                buttons: ['Ok']
            }).then(alert => alert.present());
        },
        async getUsers() {
            return this.$http.get('/api/users', {
                params: {permissions: 'warehouse.pack', all: true}
            }).then(response => {
                this.users = response.data.items;
            }).catch(error => {
                this.$validationAlert(error);
            });
        },
        refresh(event = null) {
            return this.$http.get('/api/packs/shipments', {
                params: {include: 'packers,lines,lines.item,lines.location', all: true}
            }).then(response => {
                this.shipments = PrioritySorter.sortByPriorityThen(response.data.items, 'reference');
            }).finally(() => {
                if (event && event.target.complete) {
                    event.target.complete();
                }
            });
        }
    },
    setup() {
        return {listOutline};
    }
}
</script>
